import { render, staticRenderFns } from "./ktg_attorney.vue?vue&type=template&id=27de3222&scoped=true&"
import script from "./ktg_attorney.vue?vue&type=script&lang=js&"
export * from "./ktg_attorney.vue?vue&type=script&lang=js&"
import style0 from "./ktg_attorney.vue?vue&type=style&index=0&id=27de3222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27de3222",
  null
  
)

export default component.exports